// Portuguese translations
export default {
  welcome: 'Bem-vindo',
  tapToUnmute: 'Toque para ativar o som',
  likeHint: 'Curta se você gostou',
  previousEpisode: 'Anterior',
  nextEpisode: 'Próximo',
};

